import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { MdAccessTime, MdScore } from "react-icons/md";
import { GiRoad, GiStopSign } from "react-icons/gi";
import { BsFuelPumpFill } from "react-icons/bs";
import { SlSizeActual } from "react-icons/sl";
import { IoIosWarning, IoMdSpeedometer } from "react-icons/io";
import { IoTimerOutline } from "react-icons/io5";

const RouteTile = ({ cardSliderInfo }) => {
  const [card, SetCard] = useState([]);

  const icons = [
    { icon: <GiRoad className="h-7 w-7 text-blue-1000" /> },
    { icon: <BsFuelPumpFill className="h-7 w-7 text-blue-1000" /> },
    { icon: <MdAccessTime className="h-7 w-7 text-blue-1000" /> },
    { icon: <GiStopSign className="h-7 w-7 text-blue-1000" /> },
    { icon: <IoIosWarning className="h-7 w-7 text-blue-1000" /> },
    { icon: <MdScore className="h-7 w-7 text-blue-1000" /> },
    { icon: <IoMdSpeedometer className="h-7 w-7 text-blue-1000" /> },
    { icon: <IoTimerOutline className="h-7 w-7 text-blue-1000" /> },
    { icon: <SlSizeActual className="h-7 w-7 text-blue-1000" /> },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 2,
    slidesPerRow: 1,
    rows: 2,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  useEffect(() => {
    if (cardSliderInfo && cardSliderInfo.length) {
      SetCard(cardSliderInfo);
    }
  }, [cardSliderInfo]);

  return (
    <Slider {...settings}>
      {card.map((card, index) => (
        <div
          key={card.id}
          className="relative  h-44 rounded-[6px] bg-white bg-clip-border dark:!bg-navy-800 dark:text-white dark:shadow-none"
        >
          <div className="ml-[18px] flex h-[90px] w-auto flex-row items-center">
            <div className="rounded-full bg-white p-3 dark:bg-navy-700 shadow-3xl">
              <span className="flex items-center text-brand-500 dark:text-white">
                {icons[index % icons.length].icon}
              </span>
            </div>
          </div>

          <div className="h-50 ml-4 flex w-auto flex-col justify-center">
          <h4 className="text-l font-bold text-navy-700 dark:text-white">
              {card.cardName}
            </h4>
            <p className="text-l font-dm font-medium text-gray-600">
              {card.value}
            </p>
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default React.memo(RouteTile);
